import { ProviderControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 * @author rajkumar rathod
 */
export const useUpdateProviderUserStatus = () =>
  useMutationWithLoading(
    async (params: {
      providerId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new ProviderControllerApi(getConfigObject()).updateProviderStatus(
        params?.providerId,
        params?.status,
        params?.xTENANTID
      )
  );
